import { Injectable, NgZone, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "./local-storage.service";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class IdleTimeoutService implements OnDestroy {
  private timeoutId: any;
  private readonly TIMEOUT_DURATION =
    environment.SESSION_EXP_TIMEOUT_MINUTES * 60 * 1000; // 15 minutes in milliseconds
  private readonly activityEvents = [
    "click",
    "mousemove",
    "keypress",
    "scroll",
    "touchstart",
  ];

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private localstorage: LocalStorageService,
    private toster: ToastrService
  ) {
    this.startWatching();
    this.setupActivityListeners();
  }

  private startWatching() {
    this.resetTimer();
  }

  private resetTimer() {
    if (this.localstorage.getLocalStorageItem("token")) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(
        () => this.logoutUser(),
        this.TIMEOUT_DURATION
      );
    }
  }

  private setupActivityListeners() {
    this.activityEvents.forEach((event) => {
      window.addEventListener(event, this.resetTimer.bind(this)); // Binding resetTimer to maintain context
    });
  }

  // private setupActivityListeners() {
  //   // Monitor user activity (mouse movements, key presses, etc.)
  //   ["click", "mousemove", "keypress", "scroll", "touchstart"].forEach(
  //     (event) => {
  //       window.addEventListener(event, () => {
  //         this.resetTimer();
  //       });
  //     }
  //   );
  // }

  ngOnDestroy() {
    // Clean up event listeners to avoid memory leaks
    this.activityEvents.forEach((event) => {
      window.removeEventListener(event, this.resetTimer.bind(this));
    });

    // Clear the timeout if the service is destroyed
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  private logoutUser() {
    this.ngZone.run(() => {
      this.localstorage.logout();
      this.toster.error("You have been logged out due to inactivity.");
      this.router.navigateByUrl("auth/login");
    });
  }
}
